import { navigate } from 'gatsby';

export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `This tutorial has been updated. ` + `Reload to display the latest version?`
  );
  if (answer === true) {
    window.location.reload();
  }
};

export const onRouteUpdate = ({ location }) => {
  location.pathname === '/' && navigate('/xr_glasses/introducing_xr_glasses', { replace: true });
  (location.pathname === '/xr_glasses' || location.pathname === '/xr_glasses/') &&
    navigate('/xr_glasses/introducing_xr_glasses', { replace: true });
  (location.pathname === '/neckband' || location.pathname === '/neckband/') &&
    navigate('/neckband/introducing_neckband', { replace: true });
  (location.pathname === '/mobile_dock' || location.pathname === '/mobile_dock/') &&
    navigate('/mobile_dock/introducing_mobile_dock', { replace: true });
  var contentEl = document.getElementById('content');
  contentEl && (contentEl.scrollTop = 0);
};

export const onClientEntry = () => {
  window.addEventListener('message', function (event) {
    if (event.data.type === 'gorgias-contact-form-loaded') {
      event.source.postMessage(
        {
          type: 'gorgias-parent-url',
          parentUrl: window.location.href,
        },
        '*'
      );
    }
  });
};
